import { useEffect, useState } from 'react';

// One-day closure in Europe/Copenhagen (CET on 30 October 2026).
const START = Date.parse('2026-10-30T00:00:00+01:00');
const END = Date.parse('2026-10-31T00:00:00+01:00');
const isClosed = () => Date.now() >= START && Date.now() < END;

export default function usePhoneClosure() {
  const [closed, setClosed] = useState(isClosed);
  useEffect(() => {
    let timer;
    const refresh = () => {
      clearTimeout(timer);
      setClosed(isClosed());
      const now = Date.now();
      const next = now < START ? START : END;
      if (next > now) timer = setTimeout(refresh, Math.min(next - now, 2147483647));
    };
    refresh();
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
  return closed;
}